// const chatbotApi = 'http://son.aniplustv.com:3070';
const chatbotApi = 'https://api.aniplustv.com:3000';

export { chatbotApi };
